// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/pilot-communication-partners.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/pilot-communication-partners/pilot-communication-partners.js';

mount([g0]);
